import { Controller } from "@hotwired/stimulus"

// Уникальность лиц в табеле: лицо, выбранное в одной строке, скрывается
// в селектах остальных строк. Работает совместно с select2 (обновляем через
// window.jQuery, если select2 уже инициализировал jQuery) и с cocoon.
export default class extends Controller {
  connect() {
    this.refresh = this.refresh.bind(this)
    this.element.addEventListener("change", this.refresh)
    this.element.addEventListener("cocoon:after-insert", this.refresh)
    this.element.addEventListener("cocoon:after-remove", this.refresh)
    this.refresh()
  }

  disconnect() {
    this.element.removeEventListener("change", this.refresh)
    this.element.removeEventListener("cocoon:after-insert", this.refresh)
    this.element.removeEventListener("cocoon:after-remove", this.refresh)
  }

  selects() {
    return Array.from(this.element.querySelectorAll("[data-timesheet-target='payable']"))
      .filter((s) => {
        const row = s.closest("[data-row]")
        const destroy = row?.querySelector("input[name*='_destroy']")
        return !(destroy && destroy.value === "1")
      })
  }

  refresh() {
    const selects = this.selects()
    const chosen = new Set(selects.map((s) => s.value).filter(Boolean))

    selects.forEach((select) => {
      const current = select.value
      Array.from(select.options).forEach((opt) => {
        if (!opt.value) return // «— выберите лицо —»
        opt.hidden = opt.disabled = chosen.has(opt.value) && opt.value !== current
      })
      this.refreshSelect2(select)
    })
  }

  refreshSelect2(select) {
    const jq = window.jQuery
    if (jq && jq(select).data("select2")) jq(select).trigger("change.select2")
  }
}
